export default __webpack_public_path__ + "static/media/Verkettete Elemente.853838d9.jpg";